import React from 'react'
import type { EventListenerProps } from '../../../types'

export const ignoreListener = (evt: React.SyntheticEvent) => {
  evt?.stopPropagation?.()
}

export type EventListenerTypes = Omit<EventListenerProps<HTMLElement>, 'css'>

export const eventHandlers: EventListenerTypes = {
  // Clipboard Events
  onCopy: ignoreListener,
  onCut: ignoreListener,
  onPaste: ignoreListener,
  // Composition Events
  onCompositionEnd: ignoreListener,
  onCompositionStart: ignoreListener,
  onCompositionUpdate: ignoreListener,
  // Focus Events
  onFocus: ignoreListener,
  onBlur: ignoreListener,
  // Form Events
  onChange: ignoreListener,
  onBeforeInput: ignoreListener,
  onInput: ignoreListener,
  onReset: ignoreListener,
  onSubmit: ignoreListener,
  onInvalid: ignoreListener,
  // Image Events
  onLoad: ignoreListener,
  onError: ignoreListener, // also a Media Event
  // Keyboard Events
  onKeyDown: ignoreListener,
  onKeyPress: ignoreListener,
  onKeyUp: ignoreListener,
  // Media Events
  onAbort: ignoreListener,
  onCanPlay: ignoreListener,
  onCanPlayThrough: ignoreListener,
  onDurationChange: ignoreListener,
  onEmptied: ignoreListener,
  onEncrypted: ignoreListener,
  onEnded: ignoreListener,
  onLoadedData: ignoreListener,
  onLoadedMetadata: ignoreListener,
  onLoadStart: ignoreListener,
  onPause: ignoreListener,
  onPlay: ignoreListener,
  onPlaying: ignoreListener,
  onProgress: ignoreListener,
  onRateChange: ignoreListener,
  onSeeked: ignoreListener,
  onSeeking: ignoreListener,
  onStalled: ignoreListener,
  onSuspend: ignoreListener,
  onTimeUpdate: ignoreListener,
  onVolumeChange: ignoreListener,
  onWaiting: ignoreListener,
  // MouseEvents
  onAuxClick: ignoreListener,
  onClick: ignoreListener,
  onContextMenu: ignoreListener,
  onDoubleClick: ignoreListener,
  onDrag: ignoreListener,
  onDragEnd: ignoreListener,
  onDragEnter: ignoreListener,
  onDragExit: ignoreListener,
  onDragLeave: ignoreListener,
  onDragOver: ignoreListener,
  onDragStart: ignoreListener,
  onDrop: ignoreListener,
  onMouseDown: ignoreListener,
  onMouseEnter: ignoreListener,
  onMouseLeave: ignoreListener,
  onMouseMove: ignoreListener,
  onMouseOut: ignoreListener,
  onMouseOver: ignoreListener,
  onMouseUp: ignoreListener,
  // Selection Events
  onSelect: ignoreListener,
  // Touch Events
  onTouchCancel: ignoreListener,
  onTouchEnd: ignoreListener,
  onTouchMove: ignoreListener,
  onTouchStart: ignoreListener,
  // Pointer Events
  onPointerDown: ignoreListener,
  onPointerMove: ignoreListener,
  onPointerUp: ignoreListener,
  onPointerCancel: ignoreListener,
  onPointerEnter: ignoreListener,
  onPointerLeave: ignoreListener,
  onPointerOver: ignoreListener,
  onPointerOut: ignoreListener,
  onGotPointerCapture: ignoreListener,
  onLostPointerCapture: ignoreListener,
  // UI Events
  onScroll: ignoreListener,
  // Wheel Events
  onWheel: ignoreListener,
  // Animation Events
  onAnimationStart: ignoreListener,
  onAnimationEnd: ignoreListener,
  onAnimationIteration: ignoreListener,
  // Transition Events
  onTransitionEnd: ignoreListener,
}
